import { Flex, Space } from "antd";
import { t } from "i18next";
import { AppForm, AppButton } from "@/shared/Components";
import { FormInputPassword } from "@/shared/Components/Form/FormInputs/FormInputPassword";
import type { NewPasswordFormProps } from "@/entities/new-password-form/model";
import styles from "./styles.module.scss";

export const Desktop = ({
  formApi,
  handleSubmit,
  handleCancel,
  submitDisabled,
  isLoading,
}: NewPasswordFormProps) => {
  return (
    <AppForm className={styles.form} formApi={formApi} onSubmit={handleSubmit}>
      <Flex gap={32} vertical>
        <Space direction="vertical">
          <FormInputPassword
            placeholder={t("registrationPage.userInfoStep.password")}
            name="password"
            className={styles["registration-input"]}
          />
          <FormInputPassword
            placeholder={t("registrationPage.userInfoStep.confirmPassword")}
            name="confirmPassword"
            className={styles["registration-input"]}
          />
        </Space>
        <Space>
          <AppButton
            type="link"
            className={styles.cancel}
            onClick={handleCancel}
            loading={isLoading}
          >
            {t("common.cancel")}
          </AppButton>
          <AppButton
            htmlType="submit"
            type="primary"
            className={styles.submit}
            disabled={submitDisabled}
            loading={isLoading}
          >
            {t("passwordRecoveryPage.confirm")}
          </AppButton>
        </Space>
      </Flex>
    </AppForm>
  );
};
